import { sdk } from '../sdk';

export interface Income {
  _id: string;
  incomeId: number;
  receiptId: string;
  verificationCode: string;
  departmentId: string;
  departmentName: string;
  incomeTypeId: string;
  incomeTypeName: string;
  amount: number;
  accountId: string;
  accountName: string;
  accountNumber: string;
  notes?: string;
  operatorId: string;
  operatorName: string;
  operatorRole: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIncomeData {
  departmentId: string;
  incomeTypeId: string;
  amount: number;
  accountId: string;
  notes?: string;
  pcInfo?: {
    pcName: string;
    pcId: string;
    macAddress?: string;
    ipAddress?: string;
  };
}

export interface UpdateIncomeData {
  incomeTypeId?: string;
  amount?: number;
  accountId?: string;
  notes?: string;
}

export interface IncomeResponse {
  success: boolean;
  data: Income;
}

export interface IncomesResponse {
  success: boolean;
  data: Income[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface IncomeSearchParams {
  page?: number;
  limit?: number;
  departmentId?: string;
  incomeTypeId?: string;
  accountId?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
}

export const IncomesAPI = {
  async getAllIncomes(params: IncomeSearchParams = {}): Promise<IncomesResponse> {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    queryParams.append('limit', (params.limit || 50).toString());
    if (params.departmentId) queryParams.append('departmentId', params.departmentId);
    if (params.incomeTypeId) queryParams.append('incomeTypeId', params.incomeTypeId);
    if (params.accountId) queryParams.append('accountId', params.accountId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.search) queryParams.append('search', params.search);

    const response = await sdk.client.get(`/api/v1/incomes?${queryParams.toString()}`);
    return response.data || response;
  },

  async getIncomeById(id: string): Promise<Income> {
    const response = await sdk.client.get(`/api/v1/incomes/${id}`);
    return response.data || response;
  },

  async createIncome(data: CreateIncomeData): Promise<IncomeResponse> {
    const response = await sdk.client.post('/api/v1/incomes', data, {
      headers: { 'X-HRIA-Client': 'electron-desktop' },
    });
    return response.data || response;
  },

  async updateIncome(id: string, data: UpdateIncomeData): Promise<IncomeResponse> {
    const response = await sdk.client.put(`/api/v1/incomes/${id}`, data, {
      headers: { 'X-HRIA-Client': 'electron-desktop' },
    });
    return response.data || response;
  },

  async deleteIncome(id: string): Promise<{ success: boolean; message: string }> {
    const response = await sdk.client.delete(`/api/v1/incomes/${id}`);
    return response.data || response;
  },
};
